import * as t from "io-ts";
import { decode } from "io-ts-promise";
import { createEquipmentTypes } from "dora-contracts";

const {
  baseEquipmentTypeT,
  equipmentTypeT,
  equipmentTypesT,
  updateEquipmentTypeT,
} = createEquipmentTypes({
  decimal: t.string,
});

export type UpdateEquipmentType = t.TypeOf<typeof updateEquipmentTypeT>;
export type EquipmentType = t.TypeOf<typeof equipmentTypeT>;
export type BaseEquipmentType = t.TypeOf<typeof baseEquipmentTypeT>;
export const decodeEquipmentTypes = decode(equipmentTypesT);
export const decodeEquipmentType = decode(equipmentTypeT);
